var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-body" }, [
    _c("div", [
      _c("strong", [
        _vm._v(_vm._s(_vm.$translate("Ceres::Template.myAccountEmail"))),
      ]),
    ]),
    _vm._v(" "),
    !!_vm.userData ? _c("div", [_vm._v(_vm._s(_vm.userData.email))]) : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("strong", [
        _vm._v(_vm._s(_vm.$translate("Ceres::Template.myAccountPassword"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [_vm._v("***********")]),
    _vm._v(" "),
    _c("div", [
      _c("strong", [
        _vm._v(
          _vm._s(_vm.$translate("OD3dprimaV2::Template.myAccountCustomerType"))
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.currentPriceType === "b2b"
              ? _vm.$translate("OD3dprimaV2::Template.myAccountB2B")
              : _vm.$translate("OD3dprimaV2::Template.myAccountB2C")
          ) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "add-item" }, [
      _vm.isChangeMailRouteEnabled
        ? _c("span", { staticClass: "item-edit d-block mb-2" }, [
            _c(
              "button",
              {
                directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                staticClass:
                  "btn btn-primary btn-appearance btn-large btn-only-icon-xs-down",
                attrs: {
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  title: _vm.$translate("Ceres::Template.myAccountChangeEmail"),
                },
                on: { click: _vm.showChangeAccountEmail },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.myAccountChangeEmail")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "fa fa-envelope",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "item-edit d-block mb-2" }, [
        _c(
          "button",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass:
              "btn btn-primary btn-appearance btn-large btn-only-icon-xs-down",
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: _vm.$translate("Ceres::Template.myAccountChangePassword"),
            },
            on: { click: _vm.showChangeAccountPassword },
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$translate("Ceres::Template.myAccountChangePassword")
                )
              ),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-lock fa-lg",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "item-edit d-block" }, [
        _c(
          "button",
          {
            directives: [{ name: "tooltip", rawName: "v-tooltip" }],
            staticClass:
              "btn btn-primary btn-appearance btn-large btn-only-icon-xs-down",
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              title: _vm.$translate(
                "OD3dprimaV2::Template.myAccountChangeTypeTooltip"
              ),
            },
            on: { click: _vm.showChangeCustomerType },
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$translate("OD3dprimaV2::Template.myAccountChangeType")
                )
              ),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-lock fa-lg",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.isChangeMailRouteEnabled
      ? _c("div", { ref: "accountEmailModal" }, [
          _c("div", { staticClass: "modal fade" }, [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c(
                  "form",
                  {
                    staticClass: "modal-content",
                    attrs: { method: "post" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h4", { staticClass: "modal-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.myAccountChangeEmail"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close",
                          },
                          on: { click: _vm.clearFields },
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×"),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body form-horizontal" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "input-unit" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newMail,
                                  expression: "newMail",
                                },
                              ],
                              attrs: {
                                type: "email",
                                id: "newMail",
                                name: "newMail",
                                autocomplete: "off",
                                "data-autofocus": "",
                              },
                              domProps: { value: _vm.newMail },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.newMail = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "newMail" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.myAccountNewEmail"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "input-unit no-bottom" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newMail2,
                                  expression: "newMail2",
                                },
                              ],
                              attrs: {
                                type: "email",
                                id: "newMail2",
                                name: "newMail2",
                                autocomplete: "off",
                              },
                              domProps: { value: _vm.newMail2 },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.newMail2 = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "newMail2" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.myAccountRepeatEmail"
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.matchEmail,
                                  expression: "!matchEmail",
                                },
                              ],
                              staticClass: "text-danger",
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.myAccountCorrectEmail"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.matchOldEmail,
                                  expression: "matchOldEmail",
                                },
                              ],
                              staticClass: "text-danger",
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.myAccountOldEmail"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-appearance btn-block",
                          class: {
                            disabled: !_vm.isValidEmail || _vm.isLoading,
                          },
                          attrs: { type: "submit" },
                          on: { click: _vm.saveAccountEmail },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-check",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate("Ceres::Template.myAccountSave")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { ref: "accountPasswordModal" }, [
      _c("div", { staticClass: "modal fade" }, [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c(
              "form",
              {
                staticClass: "modal-content",
                attrs: { method: "post" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "Ceres::Template.myAccountChangePassword"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: { click: _vm.clearFields },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body form-horizontal" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "input-unit" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.oldPassword,
                              expression: "oldPassword",
                            },
                          ],
                          attrs: {
                            type: "password",
                            id: "old_password",
                            name: "old_password",
                            autocomplete: "old-password",
                            "data-autofocus": "",
                          },
                          domProps: { value: _vm.oldPassword },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.oldPassword = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "old_password" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.myAccountOldPassword"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "passwordFormControl", staticClass: "col-12" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "input-unit",
                            attrs: { "data-validate": "password" },
                          },
                          [
                            _c("popper", {
                              ref: "passwordHint",
                              attrs: { trigger: "focus", placement: "bottom" },
                              scopedSlots: _vm._u([
                                {
                                  key: "handle",
                                  fn: function () {
                                    return [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.newPassword,
                                            expression: "newPassword",
                                          },
                                        ],
                                        attrs: {
                                          type: "password",
                                          id: _vm._uid,
                                          name: "password",
                                          autocomplete: "new-password",
                                        },
                                        domProps: { value: _vm.newPassword },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.newPassword =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.regPasswordHintTitle"
                                              )
                                            ) +
                                            "\n                                            "
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c("ul", { staticClass: "pl-3" }, [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.regPasswordHintLength"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.regPasswordHintDigit"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.regPasswordHintChar"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: _vm._uid } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.myAccountNewPassword"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "input-unit",
                            attrs: { "data-validate": "password" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirmPassword,
                                  expression: "confirmPassword",
                                },
                              ],
                              attrs: {
                                type: "password",
                                id: _vm._uid + "-pwd_repeat",
                                name: "password",
                                autocomplete: "new-password",
                              },
                              domProps: { value: _vm.confirmPassword },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.confirmPassword = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: _vm._uid + "-pwd_repeat" } },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.myAccountRepeatPassword"
                                      )
                                    ) +
                                    "\n                                    "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.matchPassword,
                              expression: "!matchPassword",
                            },
                          ],
                          staticClass: "text-danger",
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.myAccountCorrectPassword"
                                )
                              ) +
                              "\n                                "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-appearance btn-block",
                      class: {
                        disabled: !_vm.isValidPassword || _vm.isLoading,
                      },
                      attrs: { type: "submit" },
                      on: { click: _vm.validatePassword },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-check",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.myAccountSave")
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { ref: "accountCustomerTypeModal" }, [
      _c("div", { staticClass: "modal fade" }, [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c(
              "form",
              {
                staticClass: "modal-content",
                attrs: { method: "post" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.myAccountChangeType"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: { click: _vm.clearFields },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body form-horizontal" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm.$data._billingAddress
                      ? _c(
                          "div",
                          { ref: "typeFormControl", staticClass: "col-12" },
                          [
                            _vm.currentPriceType === "b2c"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "my-account__type-hint mb-4",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$translate(
                                              "OD3dprimaV2::Template.addressChangeB2B"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input-unit",
                                      attrs: { "data-validate": "text" },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$data._billingAddress.name1,
                                            expression:
                                              "$data._billingAddress.name1",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          id: "company",
                                          name: "company",
                                          "data-autofocus": "",
                                        },
                                        domProps: {
                                          value:
                                            _vm.$data._billingAddress.name1,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.$data._billingAddress,
                                              "name1",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "company" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.addressCompany"
                                              )
                                            ) + "*"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate:text",
                                          value:
                                            _vm.requiredAddressFields.includes(
                                              "billing_address.vatNumber"
                                            ),
                                          expression:
                                            "requiredAddressFields.includes('billing_address.vatNumber')",
                                          arg: "text",
                                        },
                                      ],
                                      staticClass: "input-unit",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$data._billingAddress
                                                .vatNumber,
                                            expression:
                                              "$data._billingAddress.vatNumber",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          id: "vat_number",
                                          name: "vat_number",
                                        },
                                        domProps: {
                                          value:
                                            _vm.$data._billingAddress.vatNumber,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.$data._billingAddress,
                                              "vatNumber",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "vat_number" } },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.addressVatNumber"
                                                )
                                              ) +
                                              "\n                                            " +
                                              _vm._s(
                                                _vm.requiredAddressFields.includes(
                                                  "billing_address.vatNumber"
                                                )
                                                  ? "*"
                                                  : ""
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "my-account__type-hint mb-4",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$translate(
                                              "OD3dprimaV2::Template.addressChangeB2C"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input-unit",
                                      attrs: { "data-validate": "text" },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$data._billingAddress.name2,
                                            expression:
                                              "$data._billingAddress.name2",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          id: "first_name",
                                          name: "first_name",
                                          "data-autofocus": "",
                                        },
                                        domProps: {
                                          value:
                                            _vm.$data._billingAddress.name2,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.$data._billingAddress,
                                              "name2",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "first_name" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.addressFirstName"
                                              )
                                            ) + "*"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input-unit",
                                      attrs: { "data-validate": "text" },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$data._billingAddress.name3,
                                            expression:
                                              "$data._billingAddress.name3",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          id: "last_name",
                                          name: "last_name",
                                        },
                                        domProps: {
                                          value:
                                            _vm.$data._billingAddress.name3,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.$data._billingAddress,
                                              "name3",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { attrs: { for: "last_name" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.addressLastName"
                                              )
                                            ) + "*"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-appearance btn-block",
                      class: { disabled: _vm.isLoading },
                      attrs: { type: "submit", disabled: _vm.isLoading },
                      on: { click: _vm.validateCustomerType },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-check",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.myAccountSave")
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }